//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconMiscPackage(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M21 9H22V3H2V9H19V18.9961H5V11H3V20.9961H21V9ZM4.22222 5V7H19.7778V5H4.22222Z" fill="currentColor" /><path d="M15 13L9 13V11H15V13Z" fill="currentColor" /></svg>;
}
export default IconMiscPackage;